module.exports = __webpack_public_path__ + "static/media/filled_bar_postlapSMAP_tall.f8f39a22.svg";